import React, { useEffect } from 'react';

import Heading from '@atlaskit/heading';
import SectionMessage from '@atlaskit/section-message';
import { startCurityLogin } from 'src/services/session/curityLogin';

const InfoPanel = () => {
  useEffect(() => {
    startCurityLogin();
  });

  return (
    <SectionMessage appearance="info">
      Redirecting to PagerDuty login page....
    </SectionMessage>
  );
};

const OauthBegin = () => (
  <div style={{ maxWidth: '700px', margin: 'auto', padding: '20px' }}>
    <Heading size="medium">PagerDuty Login</Heading>
    <br/>
    <InfoPanel/>
  </div>
);

export default OauthBegin;
